var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("grid-layout__item gl-w-" + (_vm.widget.w) + " gl-x-" + (_vm.widget.x) + " " + (_vm.isCard ? 'u-padding-4-px' : ''))},[_c('div',{staticClass:"grid-layout__item--content"})])}
var staticRenderFns = []

export { render, staticRenderFns }